import styles from "./styles.module.scss";
import { motion, AnimatePresence } from "framer-motion";
import { IoMdCheckmark } from "react-icons/io";

export const FormStepper = ({
  steps = [],
  currentStep,
  navigateToStep = () => {},
}) => {
  return (
    <div className={styles.stepper}>
      {steps.map((step, index) => {
        const isCompleted = currentStep > step.id;
        const isActive = currentStep === step.id;
        const isLast = index === steps.length - 1;

        return (
          <div className={styles.stepWrapper} key={step.id}>
            <div
              className={styles.step}
              onClick={() => isCompleted && navigateToStep(step.id)}
            >
              <div
                className={`${styles.stepNumber} ${
                  (isCompleted || isActive) && styles.active
                }`}
              >
                <AnimatePresence mode="wait">
                  {isCompleted ? (
                    <motion.span
                      key="check"
                      initial={{ scale: 0.6, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      exit={{ scale: 0.6, opacity: 0 }}
                    >
                      <IoMdCheckmark size={20} />
                    </motion.span>
                  ) : (
                    <motion.span
                      key="number"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                    >
                      {step.id + 1}
                    </motion.span>
                  )}
                </AnimatePresence>
              </div>

              <p
                className={`${styles.stepTitle} ${
                  isActive && styles.activeTitle
                }`}
              >
                {step.title}
              </p>
            </div>

            {/* connector BETWEEN steps */}
            {!isLast && <div className={styles.connector} />}
          </div>
        );
      })}
    </div>
  );
};
